import type { HistoryEventPayload } from "models/HistoryEventPayload";

export type HistoryEventType = {
  timestamp: Date | null;
  primaryDescription: string;
  secondaryDescriptions: string[];
  category: string;
};

const parseIsoDate = (value: string | null): Date | null => {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const buildHistoryEventFromPayload = ({
  timestamp,
  ...rest
}: HistoryEventPayload): HistoryEventType => ({
  ...rest,
  timestamp: parseIsoDate(timestamp),
});
